import { render } from "./ReservaFerramentas.vue?vue&type=template&id=992010e8&scoped=true"
import script from "./ReservaFerramentas.vue?vue&type=script&lang=js"
export * from "./ReservaFerramentas.vue?vue&type=script&lang=js"

import "./ReservaFerramentas.vue?vue&type=style&index=0&id=992010e8&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992010e8"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QLinearProgress,QTable,QCard,QTooltip,QImg,QTr,QTh,QTd,QBtn,QPagination,QInput,QIcon});
